module.exports = __webpack_public_path__ + "img/td_D1.4 (_Main Technical Parameter_).31cf5452.png";